import VUE_APP_API_ZKPCURL_URL from './getapi/zkway'

let apiURL = ''
// console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  apiURL = 'http://proxy.jiankanghao.net:50280'
}else {
  // alert("生产环境");
  apiURL = VUE_APP_API_ZKPCURL_URL
}

export default apiURL;
